/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 3500 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Hajji Mohamed Amine",
  title: "Hello, I'm",
  subTitle: emoji(
    "I'm Amine — Engineer, Freelancer & Technology Enthusiast. I bring my expertise to innovative projects and stay constantly ahead of the technologies shaping our world. Welcome to my portfolio!"
  ),
  resumeLink:
    "https://drive.google.com/file/d/1FXOXRpQsqAYf-x6yj85Qbvf0pjJD-Q5o/view?usp=sharing",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/jupman17",
  linkedin: "https://www.linkedin.com/in/mohamed-amine-hajji-394b71277/",
  gmail: "hajjiamineoutlook@gmail.com",
  stackoverflow: "https://stackoverflow.com/users/14845963/jup-man",
  display: true
};

// Skills Section

const skillsSection = {
  title: "Who Am I?",
  subTitle:
    "I'm Mohamed Amine. I build digital products that don't just work, they perform. From sleek web apps to blockchain solutions, I turn ideas into scalable, high-impact systems with a focus on speed, clarity, and user experience. If you're looking for something solid, modern, and built to last, that's what I do.",
  skills: [
    emoji(
      "⚡ Build highly interactive Front-end / User Interfaces for web and mobile applications"
    ),
    emoji("⚡ Progressive Web Applications (PWA) in standard and SPA stacks"),
    emoji(
      "⚡ Integration of third-party services such as Firebase / AWS / Digital Ocean"
    )
  ],

  softwareSkills: [
    { skillName: "html-5",      fontAwesomeClassname: "fab fa-html5" },
    { skillName: "css3",        fontAwesomeClassname: "fab fa-css3-alt" },
    { skillName: "sass",        fontAwesomeClassname: "fab fa-sass" },
    { skillName: "JavaScript",  fontAwesomeClassname: "fab fa-js" },
    { skillName: "reactjs",     fontAwesomeClassname: "fab fa-react" },
    { skillName: "nodejs",      fontAwesomeClassname: "fab fa-node" },
    { skillName: "swift",       fontAwesomeClassname: "fab fa-swift" },
    { skillName: "npm",         fontAwesomeClassname: "fab fa-npm" },
    { skillName: "sql-database",fontAwesomeClassname: "fas fa-database" },
    { skillName: "aws",         fontAwesomeClassname: "fab fa-aws" },
    { skillName: "firebase",    fontAwesomeClassname: "fas fa-fire" },
    { skillName: "python",      fontAwesomeClassname: "fab fa-python" }
  ],
  display: true
};

// Education Section

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Université Hassan II — Casablanca",
      logo: require("./assets/images/uh2logo-new.png"),
      subHeader: "PhD, Engineering Sciences",
      duration: "2024 — Present",
      desc: ""
    },
    {
      schoolName: "ESITH",
      logo: require("./assets/images/esithlogojpg.png"),
      subHeader: "Engineering Degree — Industrial Engineering",
      duration: "September 2022 — Present",
      desc: ""
    },
    {
      schoolName: "CPGE",
      logo: require("./assets/images/cpgelogo.png"),
      subHeader: "Preparatory Classes — Mathematics & Physics",
      duration: "September 2020 — June 2022",
      desc: ""
    },
    {
      schoolName: "Groupe Scolaire AL MAARIF",
      logo: require("./assets/images/maariflogo.png"),
      subHeader: "International Baccalaureate — Mathematical Sciences (French track)",
      duration: "July 2020",
      desc: ""
    }
  ]
};

// Your top proficient stacks/tech experience

const techStack = {
  viewSkillBars: true,
  experience: [
    { Stack: "Frontend / Design",       progressPercentage: "90%" },
    { Stack: "Blockchain Development",  progressPercentage: "80%" },
    { Stack: "Backend",                 progressPercentage: "70%" },
    { Stack: "Cybersecurity",           progressPercentage: "50%" }
  ],
  displayCodersrank: true
};

// Work experience section

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Lead Blockchain & Frontend Developer",
      company: "CoinCreate",
      companylogo: require("./assets/images/coincreate-dynamic.png"),
      date: "September 2023 — Present",
      desc: "Leading blockchain and frontend development at CoinCreate — a comprehensive Web3 platform for deploying tokens, staking contracts, and NFT collections. Building no-code solutions for blockchain deployment across Ethereum, Arbitrum, and Optimism.",
      backgroundColor: "#FFDD57",
      isClickable: true,
      websiteUrl: "https://coincreate.io",
      style: {
        transform: "scale(1.05)",
        zIndex: 1,
        boxShadow: "0 10px 30px -15px rgba(0, 0, 0, 0.2)",
        position: "relative",
        top: "-10px",
        marginBottom: "20px"
      }
    },
    {
      role: "Intern — Logistics",
      company: "LEAR CORPORATION",
      companylogo: require("./assets/images/learlogo.png"),
      desc: "Internship in the Logistics Department focused on the Warehouse Management System (WMS). Worked with the company's SAP system, managing live client orders and overseeing warehouse operations."
    },
    {
      role: "Intern — Front-end Engineer",
      company: "iXPath",
      companylogo: require("./assets/images/logo_ix.png"),
      desc: "Coordinated with front-end and back-end teams to resolve support issues on iXPath's GitLab. Built a React app that automates the generation of monthly closed-ticket reports for each assignee — available on GitHub."
    }
  ]
};

const openSource = {
  showGithubProfile: "true",
  display: false
};

// Major Projects

const bigProjects = {
  title: "My Major Projects",
  subtitle: "TECHNOLOGY SOLUTIONS I BUILT",
  projects: [
    {
      image: require("./assets/images/coincreate-namelog.png"),
      projectName: "CoinCreate",
      projectDesc:
        "A full Web3 platform for deploying tokens, staking contracts, and NFT collections. A no-code solution simplifying blockchain development on Ethereum, Arbitrum, and Optimism. As Lead Developer, I drive the frontend and blockchain development of this revolutionary platform.",
      footerLink: [{ name: "Visit", url: "https://coincreate.io/" }],
      style: { backgroundColor: "#000000", color: "#ffffff" }
    },
    {
      image: require("./assets/images/promostone.png"),
      projectName: "Promostone",
      projectDesc:
        "A complete integrated management solution covering inventory, sales, and invoicing. A professional application allowing employees to efficiently manage all of the company's commercial operations.",
      footerLink: [{ name: "Visit", url: "https://distristone.com/" }]
    },
    {
      image: require("./assets/images/schoolCollection.png"),
      projectName: "School-Collection",
      projectDesc:
        "An innovative SaaS school management platform currently in development. A tailored solution to modernize and simplify the administration of educational institutions. Coming soon 😊",
      footerLink: [{ name: "Project Preview", url: "https://school-collection.vercel.app" }]
    }
  ],
  display: true
};

// Certifications Section

const achievementSection = {
  title: emoji("My Certifications 🏆"),
  subtitle: "Industry-recognized certifications in development, AI & cybersecurity",

  achievementsCards: [
    {
      title: "Advanced React",
      subtitle: "Meta — Advanced React development certification covering hooks, performance, and patterns.",
      image: "/images/meta-cert.svg",
      imageAlt: "Meta Logo",
      footerLink: [
        { name: "View Certificate", url: "https://drive.google.com/file/d/1aBybiAtLynbPX29izUlqnghJvTDtfxU9/view?usp=sharing" }
      ]
    },
    {
      title: "Python for Data Science, AI & Development",
      subtitle: "IBM — Comprehensive Python programming for data science and AI applications.",
      image: "/images/ibm-cert.svg",
      imageAlt: "IBM Logo",
      footerLink: [
        { name: "View Certificate", url: "https://drive.google.com/file/d/1dmCMtrLxRP9vwgoYX-PLRagnPbu59YV7/view?usp=sharing" }
      ]
    },
    {
      title: "Fortinet Certified Fundamentals in Cybersecurity",
      subtitle: "Fortinet — Foundational cybersecurity knowledge covering threats, architecture, and best practices.",
      image: "/images/fortinet-cert.svg",
      imageAlt: "Fortinet Logo",
      footerLink: [
        { name: "View Certificate", url: "https://drive.google.com/file/d/1pLhN8tWMw5RlaRVrzaRJDIHzBWi-O8ZD/view?usp=sharing" }
      ]
    },
    {
      title: "Power BI Fundamentals",
      subtitle: "DataCamp — Data visualization and business intelligence using Microsoft Power BI.",
      image: "/images/datacamp-cert.svg",
      imageAlt: "DataCamp Logo",
      footerLink: [
        { name: "View Certificate", url: "https://drive.google.com/file/d/1CgeQEKcyDv9ieYVNxVSTLYUiuEX80qBx/view?usp=sharing" }
      ]
    },
    {
      title: "Business English: Networking",
      subtitle: "Coursera — Professional English communication skills for international business contexts.",
      image: "/images/coursera-cert.svg",
      imageAlt: "Coursera Logo",
      footerLink: [
        { name: "View Certificate", url: "https://drive.google.com/file/d/1SZgy7a2gW9bk7Z7T1QNhJmzStFDXLqbE/view?usp=sharing" }
      ]
    },
    {
      title: "Hosting a Static Website",
      subtitle: "Coursera — Deploying HTML/CSS/JavaScript static websites to the cloud.",
      image: "/images/coursera-cert.svg",
      imageAlt: "Coursera Logo",
      footerLink: [
        { name: "View Certificate", url: "https://drive.google.com/file/d/1z7tV_vknnh0W2tRAoAVvLR0V6qyfHY_h/view?usp=sharing" }
      ]
    },
    {
      title: "Avalanche Fundamentals",
      subtitle: "Ava Labs Academy — Core concepts of the Avalanche blockchain: architecture, subnets, and consensus.",
      image: "/images/avalanche-cert.svg",
      imageAlt: "Avalanche Logo",
      footerLink: [
        { name: "View Certificate", url: "https://drive.google.com/file/d/1pL7Trzu6_3le6fUHUmI3c8J_Id9-KJbX/view?usp=sharing" }
      ]
    },
    {
      title: "Blockchain Basics",
      subtitle: "Ava Labs Academy — Foundational blockchain concepts: distributed ledgers, cryptography, and consensus mechanisms.",
      image: "/images/blockchain-cert.svg",
      imageAlt: "Blockchain Basics Logo",
      footerLink: [
        { name: "View Certificate", url: "https://drive.google.com/file/d/1olTq91nak1oS_w-0DvHA7VaBpNLRcYk_/view?usp=sharing" }
      ]
    }
  ],
  display: true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle: "With a love for building cool things, I enjoy writing and sharing what I learn.",
  displayMediumBlogs: "true",
  blogs: [],
  display: false
};

// Talks Section

const talkSection = {
  title: "TALKS",
  subtitle: emoji("I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"),
  talks: [],
  display: false
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",
  podcast: [],
  display: false
};

const contactInfo = {
  title: emoji("Let's Work Together ☎️"),
  subtitle: "Open to projects, freelance work, and new opportunities. Feel free to reach out!",
  number: "+212 701086865",
  email_address: "hajjiamineoutlook@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter",
  display: false
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
